import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, inputClasses, inputLabelClasses } from '@mui/material';
import Home from '../home/Home';
import FundRqst_service from '../../Services/FundRqst_service';
import Snackbar from '../Snacbar'
import { getUserId } from '../Utils/Common';
import FileSaver from 'file-saver';
import { Col, Row } from 'react-bootstrap';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        }
    },
});
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item1 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item2 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: 'black',
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Times New Roman',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
    },
}));

function FundApproval() {
    const [fundaprvldetails, setfundaprvldetails] = useState([])
    const [fundaprvldetails2, setfundaprvldetails2] = useState([])
    const [fundaprvldetails3, setfundaprvldetails3] = useState([])
    const [fundaprvldetails4, setfundaprvldetails4] = useState([])
    const [fundaprvldetails5, setfundaprvldetails5] = useState([])
    // const [paymentcopydetails, setpaymentcopydetails] = useState([])

    //
    const [FilteredDetails, setFilteredDetails] = useState([])
    const [FilteredDetails2, setFilteredDetails2] = useState([])

    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severit, setseverit] = useState('');
    const [status, setstatus] = useState('')
    const [fundstatusdrp, setfundstatusdrp] = useState([])
    const [vendordrp, setvendordrp] = useState([])
    const [Paymentmode, setPaymentmode] = useState([])
    const [FundApprovalvalues, setFundApprovalvalues] = useState({
        cmid: '',
        purpose_pmtid: '',
        purpose_reqpurid: '',
        purposeSummary_id: '',

        requestamt: '',

        fundstatus: '',
        jobNo: '',
        vendorType: '',
        aprvlAmt: '',
        Paymentmode: '',
        aprvlRmks: '',
    })

    ///Handle Change=>>
    const FundAprvl_StatusHandleChange = (e) => {
        if (e.target.value === 'JOB') {
            setstatus(1)
        } else if (e.target.value === 'VENDOR') {
            setstatus(2)
        } else if (e.target.value === 'MISCELLANEOUS') {
            setstatus(3)
        } else if (e.target.value === 'CLIENT') {
            setstatus(4)
        }
        setFundApprovalvalues({
            ...FundApprovalvalues, fundstatus: e.target.value, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '', requestamt: '',
            aprvlAmt: '', Paymentmode: '', aprvlRmks: '', jobNo: '', vendorType: '',
        })
        setFilteredDetails([])
        setFilteredDetails2([])
        setfundaprvldetails([])
        setfundaprvldetails2([])
        setfundaprvldetails3([])
        setfundaprvldetails4([])
        setfundaprvldetails5([])
        var consignmentNumber = '';
        if (e.target.value === 'JOB') {
            if (FundApprovalvalues.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = FundApprovalvalues.jobNo;
            }
        }
        else if (e.target.value !== 'JOB') {
            if (FundApprovalvalues.vendorType === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = FundApprovalvalues.vendorType;
            }
        }
        let details = { consignmentNumber: consignmentNumber, status: '2', requestStatus: e.target.value }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setfundaprvldetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: consignmentNumber, status: '2', requestStatus: e.target.value }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setfundaprvldetails4(res.data); setFilteredDetails2(res.data) });
        ////paymentMode
        FundRqst_service.getBillPaymentType().then(res => { setPaymentmode(res.data); });

        if (e.target.value === 'JOB') {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(false)
        }
        else if (e.target.value === 'VENDOR' || e.target.value === 'MISCELLANEOUS' || e.target.value === 'CLIENT') {
            FundRqst_service.getVendorType(e.target.value).then(res => {
                setvendordrp(res.data)
            });
            SetVendorHidden(false)
            SetJobHidden(true)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(true)
        }
        else if (e.target.value === "") {
            SetVendorHidden(true)
            SetJobHidden(true)
            setdesignHidden(true)
            settablehidden(true)
            setsearchbtnhidden(true)
        }
    }
    const fundAprvl_jobNoHandleChange = (e) => {
        setFundApprovalvalues({ ...FundApprovalvalues, jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const fundAprvl_vendortypHandleChange = (e) => {
        setFundApprovalvalues({ ...FundApprovalvalues, vendorType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
        let details = { consignmentNumber: e.target.value, status: '2', requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setfundaprvldetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: e.target.value, status: '2', requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setfundaprvldetails4(res.data); setFilteredDetails2(res.data) });
    }
    const fundAprvl_AprvlamtHandleChange = (e) => {
        setFundApprovalvalues({ ...FundApprovalvalues, aprvlAmt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const fundAprvl_AprvlpaymntmdHandleChange = (e) => {
        setFundApprovalvalues({ ...FundApprovalvalues, Paymentmode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const fundAprvl_AprvlRmksHandleChange = (e) => {
        setFundApprovalvalues({ ...FundApprovalvalues, aprvlRmks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FundStsName = () => {
        if (status === 1) {
            return 'Job No';
        }
        else if (status === 2) {
            return 'VENDOR';
        }
        else if (status === 3) {
            return 'MISCELLANEOUS';
        }
        else if (status === 4) {
            return 'CLIENT';
        }
    }
    //keydown
    const approvalkeydown = (e) => {
        if (e.key === 'Enter') {
            document.getElementById('paymentmode').focus()
        }
    }
    const paymentMdkeydown = (e) => {
        if (e.key === 'Enter') {
            document.getElementById('rmksid').focus()
        }
    }
    ///hidden
    const [designHidden, setdesignHidden] = useState(true);
    const [tablehidden, settablehidden] = useState(true);
    const [VendorHidden, SetVendorHidden] = useState(true);
    const [JobHidden, SetJobHidden] = useState(false);
    const [searchbtnhidden, setsearchbtnhidden] = useState(true);

    ///buttons
    const [aprovalBtnDis, setaprovalBtnDis] = useState(true)
    const [updateBtnDis, setupdateBtnDis] = useState(true)
    const [NonAPrvBtnDis, setNonAPrvBtnDis] = useState(true)
    const [DownloadRqstBtnDis, setDownloadRqstBtnDis] = useState(true)

    ///processing
    const [aprovalPros, setaprovalPros] = useState(false)
    const [updatePros, setupdatePros] = useState(false)
    const [nonaprovalPros, setnonaprovalPros] = useState(false)
    const [DwnldReqCopyPros, setDwnldReqCopyPros] = useState(false)
    const [refreshPros, setrefreshPros] = useState(false)

    ////reset Btns....>
    const resetbuttons = () => {
        setaprovalBtnDis(true)
        setupdateBtnDis(true)
        setNonAPrvBtnDis(true)
        setDownloadRqstBtnDis(true)
    }
    ///clearOperation>>>>>>
    const resetalloperations = () => {
        setFundApprovalvalues({
            ...FundApprovalvalues, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '', requestamt: '',
            aprvlAmt: '', Paymentmode: '', aprvlRmks: '', jobNo: ''
        });
        setFilteredDetails2([])
        setFilteredDetails([])
        setfundaprvldetails([]);
        setfundaprvldetails2([]);
        setfundaprvldetails3([]);
        setfundaprvldetails4([]);
        setfundaprvldetails5([]);
        resetbuttons();
        Getpaymentjob_nonjob_no();
        setaprovalPros(false)
        setupdatePros(false)
        setnonaprovalPros(false)
        setDwnldReqCopyPros(false);
        document.getElementById('fundstatus').focus();
        setrefreshPros(false)

    }
    ///validation
    const Approvalvalidation = () => {
        if (FundApprovalvalues.aprvlAmt !== '') {
            if (FundApprovalvalues.Paymentmode !== '') {
                console.log('paymntcd ======' + JSON.toString(FundApprovalvalues.Paymentmode))
                return true;
            } else {
                setMessage('Please Enter Payment Mode..Warning ..!!');
                setseverit('warning');
                setOpen(true);
                document.getElementById('paymentmode').focus();
            }
        } else {
            setMessage('Please Enter Payment Request Amount ..Warning ..!!');
            setseverit('warning');
            setOpen(true);
            document.getElementById('aprvlamnt').focus();
        }
        return false;
    }
    //////

    const Jobserachbtn = () => {
        setaprovalBtnDis(true)
        setupdateBtnDis(true)
        setNonAPrvBtnDis(true)
        setDownloadRqstBtnDis(true)
        setFundApprovalvalues({
            ...FundApprovalvalues, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', requestamt: '', aprvlAmt: '', Paymentmode: '', aprvlRmks: ''
        });
        setfundaprvldetails2([])
        setfundaprvldetails3([])
        Getpaymentjob_nonjob_no();
    }
    const [selected, setSelected] = useState([]);
    const [selected1, setSelected1] = useState([]);
    /////
    const getnonpurpose = (trns) => {
        setfundaprvldetails5([])
        const selectedIndex = selected.indexOf(trns.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignmentNumber);
        }
        setSelected(newSelected);
        setfundaprvldetails2([])
        setaprovalBtnDis(true)
        setupdateBtnDis(true)
        setNonAPrvBtnDis(true)
        setDownloadRqstBtnDis(true)
        setFundApprovalvalues({ ...FundApprovalvalues, cmid: trns.cmId, purpose_pmtid: '', requestamt: '', aprvlAmt: '', Paymentmode: '', aprvlRmks: '' })

        setfundaprvldetails3([]);

        let details = { cmId: trns.cmId, status: '2', requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentReqPurpose(details).then(res => {
            setfundaprvldetails2(res.data);
        });

        let details2 = { paymentId: trns.cmId, requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentSummaryDetails(details2).then(res => {
            setfundaprvldetails5(res.data);
        })
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    ///
    const nonverifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.reqAmount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.reqAmount);
        }
        setSelected1(newSelected);
        setaprovalBtnDis(false)
        setupdateBtnDis(true)
        setNonAPrvBtnDis(true)
        setDownloadRqstBtnDis(false)
        getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 1)
        setfundaprvldetails3([]);


    }
    const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///
    const verifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.reqAmount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.reqAmount);
        }
        setSelected1(newSelected);
        setaprovalBtnDis(true)
        setupdateBtnDis(false)
        setNonAPrvBtnDis(false)
        setDownloadRqstBtnDis(false)
        getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 2)

        // let details = { cmId: FundApprovalvalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
        // FundRqst_service.getPaymentCopy(details).then(res => {
        //     setpaymentcopydetails(res.data);
        // })
    }
    const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///
    const getpurpose = (trns) => {
        console.log('cmid=='+JSON)
        setfundaprvldetails5([])
        const selectedIndex = selected.indexOf(trns.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignmentNumber);
        }
        setSelected(newSelected);
        setfundaprvldetails3([])
        setaprovalBtnDis(true)
        setupdateBtnDis(true)
        setNonAPrvBtnDis(true)
        setDownloadRqstBtnDis(true)
        setFundApprovalvalues({ ...FundApprovalvalues, cmid: trns.cmId, purpose_pmtid: '', requestamt: '', aprvlAmt: '', Paymentmode: '', aprvlRmks: '' })
        setfundaprvldetails2([]);

        let details = { cmId: trns.cmId, status: '6', requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentReqPurpose(details).then(res => {
            setfundaprvldetails3(res.data);
        });

        let details2 = { paymentId: trns.cmId, requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentSummaryDetails(details2).then(res => {
            setfundaprvldetails5(res.data);
        })
    }
    const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
    /////
    const getpaymentdetailsAssign = (payid, reqid, val) => {
        let details = { paymentId: payid }
        FundRqst_service.getPaymentDetails(details).then(res => {
            const data = res.data;
            const details = data.map((trns) => trns);
            var txt_amount, appMode,appRemarks = '';
            if (val === 1) {
                txt_amount = details[0].reqAmount
            } else {
                txt_amount = details[0].approvalAmunt
            }
            if (details[0].appMode === null || details[0].appMode === '' || !details[0].appMode) {
                appMode = '';
            } else {
                appMode = details[0].appMode;
            }
            if (details[0].appRemarks === null || details[0].appRemarks === '' || !details[0].appRemarks) {
                appRemarks = '';
            } else {
                appRemarks = details[0].appRemarks;
            }
            setFundApprovalvalues({
                ...FundApprovalvalues, aprvlAmt: txt_amount, requestamt: details[0].reqAmount, aprvlRmks:appRemarks, Paymentmode: appMode, purpose_pmtid: payid, purpose_reqpurid: reqid
            })
        }).catch(error => {
            setMessage(error.message);
            setseverit('error');
            setOpen(true);
        })
    }
    /////
    const Getpaymentjob_nonjob_no = () => {
        var consignmentNumber = '';
        if (FundApprovalvalues.fundstatus === 'JOB') {
            if (FundApprovalvalues.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = FundApprovalvalues.jobNo;
            }
        }
        else if (FundApprovalvalues.fundstatus !== 'JOB') {
            if (FundApprovalvalues.vendorType === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = FundApprovalvalues.vendorType;
            }
        }
        let details = { consignmentNumber: consignmentNumber, status: '2', requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setfundaprvldetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: consignmentNumber, status: '2', requestStatus: FundApprovalvalues.fundstatus }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setfundaprvldetails4(res.data); setFilteredDetails2(res.data) });

    }
    ///buttons operations=================>
    const approval_and_update_operations = () => {
        if (Approvalvalidation() === true) {
            let details = {
                cmId: FundApprovalvalues.purpose_pmtid, reqAmount: null, reqPurpose: null, reqPaidTo: null, reqDate: '', reqBy: '', approvalAmunt: FundApprovalvalues.aprvlAmt, approvalDate: '',
                approvalBy: getUserId(), firstLevelAmount: null, firstLevelDat: null, firstVeryBy: null, secondLevelAmount: null, secondLevelDate: null,
                secondVeryBy: null, allocatedAmount: null, allocatedMode: FundApprovalvalues.Paymentmode, allocatedVoucherNo: null, allocatedVoucherType: null,
                allocatedVocherCopy: null, allocatedPrintedBy: null, allocatedDate: null, allocatedBy: null, status: '2', remarks: FundApprovalvalues.aprvlRmks,
                referenceNo: null, bankName: null, accountNo: null, ifsc: null, benName: null, gstinPayee: null, requestStatus: FundApprovalvalues.fundstatus,
                refundStatus: null
            }
            FundRqst_service.updatePaymentDetails(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Approved Successfully');
                    setseverit('success');
                    setOpen(true);
                    resetalloperations();
                } else {
                    setMessage('Approval Failed ..!!' + message.toString());
                    setseverit('error');
                    setOpen(true);
                    document.getElementById('aprvlamnt').focus();
                }
            }).catch(error => {
                setMessage('Approval Failed ' + error.message);
                setseverit('error');
                setOpen(true);
            })
        }
    }
    const approvalBTN = () => {
        setaprovalPros(true)
        approval_and_update_operations()
        setaprovalPros(false)
    }
    const updateBTN = () => {
        setupdatePros(true)
        approval_and_update_operations()
        setupdatePros(false)
    }
    const Nonaprvl_Btn = () => {
        setnonaprovalPros(true)
        let details = {
            cmId: FundApprovalvalues.cmid, paymentId: FundApprovalvalues.purpose_pmtid, status: '2', createdBy: getUserId(),
            requestStatus: FundApprovalvalues.fundstatus
        }
        FundRqst_service.updatePaymentStatus(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Non-Approved Successfully');
                setseverit('success');
                setOpen(true);
                resetalloperations();
            } else {
                setMessage('Non-Approval Failed ' + message.toString());
                setseverit('error');
                setOpen(true);
                document.getElementById('aprvlamnt').focus();
            }
        }).catch(error => {
            setMessage('Non-Approval Failed ' + error.message);
            setseverit('error');
            setOpen(true);
        })
        setnonaprovalPros(false)
    }
    ///////
    const saveimage = () => {
        setDwnldReqCopyPros(true)
        // const lastresult = paymentcopydetails.map((item) => item);
        let details = { cmId: FundApprovalvalues.cmid, reqPurpose: FundApprovalvalues.purpose_reqpurid, status: '1' }
        FundRqst_service.getPaymentCopy(details).then(res => {
            const data = res.data;
            const detaill = data.map(node => node.docImage)
            // console.log('before saveAs '+JSON.stringify(detaill.toString()))
            // FileSaver.saveAs(`data:image/jpeg;base64,${detaill.toString()}`, FundApprovalvalues.cmid + "-" + FundApprovalvalues.purpose_reqpurid + ".jpg");
            const filedata = detaill.toString()
            const formates = filedata.split('/9j/4');
            //    console.log('ggg '+JSON.stringify(formates))
            if (formates[0] === '') {
                FileSaver.saveAs(`data:image/jpg;base64,${detaill.toString()}`, FundApprovalvalues.cmid + "-" + FundApprovalvalues.purpose_reqpurid + ".jpg");
            } else {
                const Pngformates = filedata.split('iVBORw0KGg');
                if (Pngformates[0] === '') {
                    FileSaver.saveAs(`data:image/jpg;base64,${detaill.toString()}`, FundApprovalvalues.cmid + "-" + FundApprovalvalues.purpose_reqpurid + ".jpg");
                } else {
                    FileSaver.saveAs(`data:application/pdf;base64,${detaill.toString()}`, FundApprovalvalues.cmid + "-" + FundApprovalvalues.purpose_reqpurid + ".pdf");
                }
            }
            setDwnldReqCopyPros(false)
        }).catch(error => {
            setMessage('Insertion Failed! ,' + error.message)
            setseverit('error')
            setOpen(true)
            setDwnldReqCopyPros(false)
        })


    }
    //////
    const RefreshBtn = () => {
        setrefreshPros(true)
        setFundApprovalvalues({
            ...FundApprovalvalues, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', fundstatus: 'JOB', requestamt: '',
            aprvlAmt: '', Paymentmode: '', aprvlRmks: '', jobNo: '', vendorType: '',
        });
        setFilteredDetails([])
        setFilteredDetails2([])
        setfundaprvldetails([])
        setfundaprvldetails2([])
        setfundaprvldetails3([])
        setfundaprvldetails4([])
        setfundaprvldetails5([]);
        resetbuttons();
        setaprovalPros(false)
        setupdatePros(false)
        setnonaprovalPros(false)
        setDwnldReqCopyPros(false)
        setrefreshPros(false)
        Getpaymentjob_nonjob_no();
        document.getElementById('fundstatus').focus();
        setrefreshPros(false)
    }
    // api functions=====================>
    const FundStatusDropdown = async () => {
        FundRqst_service.getFundStatus().then(res => {
            setfundstatusdrp(res.data)
        })
    }
    //table search
    const fundSrch = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fundOnchange(e.target.value) }} />
    }
    const fundOnchange = (searchedVal) => {
        const filteredvalue = fundaprvldetails.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails(fundaprvldetails)
        } else {
            setFilteredDetails(filteredvalue)
        }
    }
    const fundSrch2 = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fund2Onchange(e.target.value) }} />
    }
    const fund2Onchange = (searchedVal) => {
        const filteredvalue = fundaprvldetails4.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails2(fundaprvldetails4)
        } else {
            setFilteredDetails2(filteredvalue)
        }
    }
    useEffect(() => {
        FundStatusDropdown();
    }, []);

    const handleClose = () => {
        setOpen(false)
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/fundreq');
    }
    const ForwordBotton = () => {
        navigate('/fund1stlvlvrfy');
    }
    return (
        <div>
            <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
            <Home />
            <div style={{ paddingLeft: '80px', transition: '1s', transitionDelay: 'revert-layer' }}>
            <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid2 container>
                    <Box style={{ width: '11.5%' }}>
                        <Item1>
                            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red', marginLeft: '15px' }}>NonApproval Job</lable>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center' }}>`{FundStsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            FilteredDetails.map((trns) => {
                                                const isItemSelected = isSelected(trns.consignmentNumber);
                                                return (
                                                    <TableRow hover selected={isItemSelected} key={trns.consignmentNumber} onClick={() => getnonpurpose(trns)}>
                                                        <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignmentNumber}</StyledTableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item1>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', fontFamily: 'Times New Roman' }}>NonApproval Purpose</lable>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center', width: '100px' }}>Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fundaprvldetails2.map((trns) => {
                                            const isItemSelected = isNonReqItemSelected(trns.reqAmount);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.reqAmount} onClick={() => nonverifypurpose(trns)}>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.serialNumber}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.reqAmount}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '37%' }}>
                        <Item>
                            <div style={{  fontFamily: 'Times New Roman',color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '2%' }}><center>FUND APPROVAL</center></div>
                            <Csscontrol fullWidth size='small' style={{ marginTop: '1.5%', width: '35%' }}>
                                <InputLabel id="demo-select-small"style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Fund Status</InputLabel>
                                <Select id='fundstatus' label="Fund Statusss" style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} onChange={FundAprvl_StatusHandleChange} value={FundApprovalvalues.fundstatus}>
                                    <MenuItem></MenuItem>
                                    {fundstatusdrp.map(status => (
                                        <MenuItem value={status.requestStatus}>{status.requestStatus}</MenuItem>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <CssTextField hidden={JobHidden} size='small' sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} style={{ marginTop: '1.5%', marginLeft: '2%', width: '35%' }} label="Job No" variant="outlined"
                                value={FundApprovalvalues.jobNo} onChange={fundAprvl_jobNoHandleChange} />

                            <Button size='small' hidden={searchbtnhidden} variant="contained" color="primary" style={{fontFamily:'Times New Roman', marginTop: '1.5%', marginLeft: '1%' }} onClick={Jobserachbtn}>Search</Button>

                            <Csscontrol hidden={VendorHidden} fullWidth size='small' style={{ marginTop: '1.5%', marginLeft: '2%', width: '35%' }}>
                                <InputLabel id="demo-select-small" >Vendor Type</InputLabel>
                                <Select label='Vendor Typeeee' style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} value={FundApprovalvalues.vendorType} native onChange={fundAprvl_vendortypHandleChange}>
                                    <option></option>
                                    {vendordrp.map(trns => (
                                        <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                                    ))}
                                </Select>
                            </Csscontrol>
                            <div hidden={designHidden}>
                                <Row className='mt-4 mb-3'>
                                    <Col xs={2}></Col>
                                    <Col xs={5}><lable style={{ fontSize: '15px',color:'black', fontFamily: 'Times New Roman',fontWeight:'bold' }}>Request Amount :</lable></Col>
                                    <Col xs={3} style={{ fontSize: '15px', color: 'Red', fontFamily: 'Times New Roman' }}>{FundApprovalvalues.requestamt}</Col>
                                    <Col xs={2}></Col>

                                </Row>
                                <div className='form-inline'>
                                    <CssTextField size='small' id='aprvlamnt' type='number' sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} style={{ marginTop: '1%', width: '230px' }} label="Approval Amount" variant="outlined"
                                        value={FundApprovalvalues.aprvlAmt} onChange={fundAprvl_AprvlamtHandleChange} onKeyDown={approvalkeydown} required />

                                    <Csscontrol fullWidth size='small' style={{ marginTop: '1%', marginLeft: '1%', width: '230px' }} onKeyDown={paymentMdkeydown} required>
                                        <InputLabel id="demo-select-small"style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Payment Mode</InputLabel>
                                        <Select id='paymentmode' label="Payment Modeee" style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} value={FundApprovalvalues.Paymentmode} native
                                            onChange={fundAprvl_AprvlpaymntmdHandleChange}>
                                            <option></option>
                                            {Paymentmode.map(trns => (
                                                <option value={trns.paymentType}>{trns.paymentType}</option>
                                            ))}
                                        </Select>
                                    </Csscontrol>
                                </div>
                                
                                <CssTextField size='small' id='rmksid' sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} style={{ marginTop: '4%', width: '230px' }} label="Approval Remarks" variant="outlined"
                                    value={FundApprovalvalues.aprvlRmks} onChange={fundAprvl_AprvlRmksHandleChange} />
                            </div>
                        </Item>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', fontFamily: 'Times New Roman' }}>Approval Purpose</lable>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center', }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center', }} >Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center', }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fundaprvldetails3.map((trns) => {
                                            const isItemSelected = isReqItemSelected(trns.reqAmount);
                                            return (
                                                <TableRow selected={isItemSelected} hover key={trns.reqPurpose} onClick={() => verifypurpose(trns)}>
                                                    <StyledTableCell style={{ color: 'darkblue', textAlign: 'center' }}>{trns.serialNumber}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue', textAlign: 'center' }}>{trns.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue', textAlign: 'center' }}>{trns.reqAmount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '11.5%' }}>
                        <Item2>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', marginRight: '30px' , fontFamily: 'Times New Roman'}}>Approval Job</lable>
                            {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center' }}>`{FundStsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch2()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails2.map((trns) => {
                                            const isItemSelected = isReqjobSelected(trns.consignmentNumber);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignmentNumber} onClick={() => getpurpose(trns)}>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignmentNumber}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item2>
                    </Box>
                </Grid2>
                <center hidden={designHidden}><div className='mt-2 mb-1 form-inline'>
                    {/* hhh */}
                    <Button size='small' style={{fontFamily:'Times New Roman'}}variant="contained" color="primary" className='mt-1' disabled={aprovalBtnDis} onClick={approvalBTN}>{aprovalPros ? 'processing...' : 'APPROVAL'}</Button>{' '}
                    <Button size='small' style={{fontFamily:'Times New Roman'}}variant="contained" className='mt-1' color="primary" disabled={updateBtnDis} onClick={updateBTN}>{updatePros ? 'processing...' : 'UPDATE'}</Button>{' '}
                    <Button size='small' style={{fontFamily:'Times New Roman'}}variant="contained" className='mt-1' color="primary" disabled={NonAPrvBtnDis} onClick={Nonaprvl_Btn}>{nonaprovalPros ? 'processing...' : 'NON APPROVAL'}</Button>{' '}
                    <Button size='small' style={{fontFamily:'Times New Roman'}}variant="contained" className='mt-1' color="primary" disabled={DownloadRqstBtnDis} onClick={saveimage}>{DwnldReqCopyPros ? 'processing...' : 'DOWNLOAd REQUEST COPY'}</Button>{' '}
                    <Button size='small' style={{fontFamily:'Times New Roman'}}variant="contained" className='mt-1' color="primary" onClick={RefreshBtn} >{refreshPros ? 'processing...' : 'REFRESH'}</Button>
                </div></center>
                <Item hidden={tablehidden}>
                    <TableContainer sx={{ maxHeight: 215 }} className='scrollbarPrime'>
                        <Table stickyHeader className='table table-bordered'>
                            <TableHead>
                            <StyledTableRow>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Sl</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Description</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }} >Request_Date</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2nd_ApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedBY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Release_BY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedBY</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {fundaprvldetails5.map((trns) => (
                                    <TableRow hover key={trns.reqPurpose}>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.serialNumber}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqPurpose}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqAmount}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }} >{trns.reqDate}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqRemarks}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqByName}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalAmunt}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalDate}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.appRemarks}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalByName}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelAmount}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelDate}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstRemarks}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelVeryBy}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelAmount}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelDate}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondRemarks}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelVeryBy}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedAmount}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedDate}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedRemarks}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedByName}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseAmount}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_date}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseRemarks}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseByName}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_amount}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_date}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_remarks}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{trns.audited_by}</StyledTableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Item>
            </div>
        </div>
    )
}

export default FundApproval